// extracted by mini-css-extract-plugin
module.exports = {"root":"icon_root__3OV_3","sizexs":"icon_sizexs__Pz7ft","sizesm":"icon_sizesm__obxYq","sizemd":"icon_sizemd__XQdRs","sizelg":"icon_sizelg__fH98X"};